import React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { colors } from 'src/theme';
import { ArrowLeftIcon } from '../icons';

const BackLinkStyle = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  cursor: 'pointer',
  fontSize: 16,
  fontWeight: 700,
  color: colors.text2,

  '&:hover': {
    color: colors.primary,
  },

  '&:hover svg path': {
    fill: colors.primary,
  },
});

interface BackLinkProps {
  text: string;
  /** Path to navigate to; if not provided, history back is used. */
  path?: string | null;
}

export const BackLink: React.FC<BackLinkProps> = ({ text, path }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path != null && path !== '') {
      navigate(path);
    } else {
      navigate(-1);
    }
  };

  return (
    <BackLinkStyle onClick={handleClick}>
      <ArrowLeftIcon color={colors.text2} width={12} height={12} />
      {text}
    </BackLinkStyle>
  );
};
